// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ty-8";
export var editMode = "_ty-3";
export var headerRow = "_ty-a";
export var headerTitle = "_ty-b";
export var product = "_ty-1";
export var productDetails = "_ty-5";
export var productDivider = "_ty-7";
export var productImage = "_ty-2";
export var productInfo = "_ty-4";
export var productTitle = "_ty-6";
export var strikethrough = "_ty-9";
export var upsellProductsCard = "_ty-0";